/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, FUNCTIONS){
	const a = 'is-active';
	const searchToggle = () => {
		$('.js-search-toggle').on('click', function () {
			$(this).toggleClass('is-active');
			$('.js-search-toggleBlock').stop().slideToggle(400);
		});
		$('.js-download-list-toggle').on('click', function () {
			$('.js-download-list-toggleBlock').toggleClass('is-active');
		});
	};
	searchToggle();

})(window.jQuery, window.FUNCTIONS);